module.exports = __webpack_public_path__ + "static/img/emptyState.c0d2c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/APRILYOS/emptyState.png
// module id = GTsK
// module chunks = 0